(function() {
  'use strict';

  angular.module('ringbaPortal').component('availableTargets', {
    bindings: {
      routeContainerType: '<', // either campaign or callplan
      routeContainer: '<',
      routeContainerRoutes: '<',
      onUpdate: '&',
      isRpc: '<'
    },
    controller: AvailableTargetsController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/select-target/available-targets.view.html'
  });

  function AvailableTargetsController(
    $scope,
    $uibModal,
    $filter,
    $timeout,
    accountsService,
    campaignServiceNew,
    callPlanService,
    callRouteService,
    targetService,
    utils
  ) {
    'ngInject';

    const vm = this;

    vm.currentRoute = {};
    vm.isRefreshingTargets = false;

    vm.$onChanges = onChanges;
    vm.cancelModal = cancelModal;
    vm.createUpdateRoute = createUpdateRoute;
    vm.newTargetRoute = newTargetRoute;
    vm.newTarget = newTarget;
    vm.onSave = onSave;
    vm.addRouteToCampaignOrCallPlan = addRouteToCampaignOrCallPlan;
    vm.refreshTargets = refreshTargets;

    function onChanges(changesObj) {
      if (changesObj.routeContainerRoutes) {
        if (changesObj.routeContainerRoutes.isFirstChange()) {
          vm.loading = true;
        }
        _loadTargets();
      }
    }

    function cancelModal() {
      vm.currentRoute = {};
      if (vm.modal) {
        vm.modal.close();
        vm.modal = null;
      }
    }

    function createUpdateRoute() {
      vm.currentRoute.targetid = vm.selectedTarget.id;
      vm.currentRoute.callTarget = vm.selectedTarget;
      return addRouteToCampaignOrCallPlan(vm.currentRoute)
        .then(function () {
          vm.onUpdate({
            routeContainer: vm.routeContainer
          });
          cancelModal();
        })
        .catch(utils.errorHandler);
    }

    function newTargetRoute(callTarget) {
      vm.selectedTarget = callTarget;
      vm.modal = $uibModal.open({
        templateUrl: '/scripts/shared/components/select-target/new-target-route.modal.html',
        scope: $scope,
        controllerAs: 'vm',
        size: 'xl'
      });
    }

    function newTarget() {
      vm.modal = $uibModal.open({
        templateUrl: '/scripts/shared/components/select-target/new-target.modal.html',
        scope: $scope,
        controllerAs: 'vm',
        size: 'xl'
      });
    }

    function onSave() {
      cancelModal();
      vm.onUpdate({
        routeContainer: vm.routeContainer
      });
    }

    function addRouteToCampaignOrCallPlan(route) {
      if (vm.routeContainerType === 'callPlan') {
        return callRouteService.createCallRoute(accountsService.currentAccountId, route).then(function (response) {
          return callPlanService.addRoute(accountsService.currentAccountId, vm.routeContainer.id, response.data.callRoute.id);
        });
      } else {
        return campaignServiceNew.addRoute(
          accountsService.currentAccountId,
          vm.routeContainer.id,
          route
        );
      }
    }

    function _loadTargets() {
      targetService.getTargets(accountsService.currentAccountId, true)
        .then(function (targets) {
          if (targets.length > 0) {
            vm.noTargetAvailableMessage = $filter('translate')('CAMPAIGN_STEP_ROUTING_ALL_TARGETS_ASSIGNED');
          } else {
            vm.noTargetAvailableMessage = $filter('translate')('CAMPAIGN_STEP_ROUTING_NONE_TARGETS');
          }

          vm.targets = $filter('notInCampaignRoutes')(targets, vm.routeContainerRoutes, 'target');
          vm.loading = false;
        })
        .catch(utils.errorHandler);
    }

    function refreshTargets() {
      vm.isRefreshingTargets = true;
      try {
        _loadTargets();
      } finally {
        $timeout(() => {
          vm.isRefreshingTargets = false;
        }, 600);
      }
    }
  }
})();
